(function() {
  'use strict';

  angular.module('app.arcgisonline')
    .factory('sessionService', sessionService);

  function sessionService($rootScope, $window, $http, $state, agoSecurity, $interval) {
    let currentUser;
    let isLoggedIn;
    let refreshFunction;

    let sessionServiceService = {
      init: init,
      resetSession: resetSession,
      agoLogin: agoLogin,
      logout: logout,
      authSuccess: authSuccess,
      authFailed: authFailed,
      getIsLoggedIn: getIsLoggedIn,
      getUser: getUser,
      getTokenInfo: getTokenInfo,
      getRole: getRole
    };
    init();
    return sessionServiceService;

    //////////// functions

    function init() {
      resetSession();
    }

    function resetSession() {
      currentUser = null;
      isLoggedIn = false;
    }

    function agoLogin() {
      $window.location.href = $window.location.origin + '/auth/arcgis';
      // var url = '/auth/arcgis',
      //   width = 1000,
      //   height = 650,
      //   top = (window.outerHeight - height) / 2,
      //   left = (window.outerWidth - width) / 2;
      // $window.open(url, 'arcgis_login', 'width=' + width + ',height=' + height + ',scrollbars=0,top=' + top + ',left=' + left);
    }

    function logout() {
      $interval.cancel(refreshFunction);
      $http.delete('/auth').success(function() {
        resetSession();
        $state.go('main');
        $rootScope.$broadcast('session-changed', isLoggedIn);
      });
    }

    function authSuccess(userData, route) {
      isLoggedIn = true;
      currentUser = angular.copy(userData);
      refreshFunction = $interval(refresh, 1320000);
      if (route === '/' || route == null) {
        $state.go('admin');
      }
      $rootScope.$broadcast('session-changed', isLoggedIn);
    }

    function authFailed() {
      resetSession();
      alert('Authentication failed');
    }

    function getIsLoggedIn() {
      return isLoggedIn;
    }

    function getUser() {
      return currentUser;
    }

    function getTokenInfo() {
      return {
        agoToken: currentUser.agoToken,
        agoUserId: currentUser.agoUserId
      };
    }

    function getRole() {
      if (currentUser != null) {
        return currentUser.role;
      } else {
        return null;
      }
    }

    function refresh() {
      // console.log('Refresh the token...');
      $http.post('/api/user/refresh').then(function(data) {
        let newTokenProps = {
          agoToken: data.data.token,
          agoUserId: currentUser.agoUserId
        };
        agoSecurity.initialize(newTokenProps);
      });

    }
  }
}());
